import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice de division longue";
const DESCRIPTION =
  "Calculatrice de division longue pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "de division longue, calculatrice de division longue, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/long-division";
function LongDivisionCalculator() {
  const [dividend, setDividend] = useState("");
  const [divisor, setDivisor] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const div = parseFloat(dividend);
      const divisor_val = parseFloat(divisor);
      if (isNaN(div) || isNaN(divisor_val) || divisor_val === 0) {
        setError("Veuillez entrer des valeurs valides");
        setResult(null);
        return;
      }
      const quotient = Math.floor(div / divisor_val);
      const remainder = div % divisor_val;
      setResult({ quotient, remainder, decimal: (div / divisor_val).toFixed(4) });
      setError("");
    } catch (err) {
      setError("Erreur de calcul");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Effectuez des divisions longues avec des étapes détaillées.</p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Dividende:</label>
                    <input
                      type="number"
                      value={dividend}
                      onChange={(e) => setDividend(e.target.value)}
                      className="form-control"
                      placeholder="Nombre à diviser"
                    />
                  </div>
                  <div className="form-group">
                    <label>Diviseur:</label>
                    <input
                      type="number"
                      value={divisor}
                      onChange={(e) => setDivisor(e.target.value)}
                      className="form-control"
                      placeholder="Diviser par"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Calculer
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {result && (
                  <div>
                    <p className="p-3 mb-2 bg-success text-white">
                      Quotient: {result.quotient}
                    </p>
                    <p className="p-3 mb-2 bg-success text-white">
                      Reste: {result.remainder}
                    </p>
                    <p className="p-3 mb-2 bg-info text-dark">
                      Décimal: {result.decimal}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Calculatrice de division longue</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        <strong>Qu'est-ce que la calculatrice de division longue ?</strong>
                        Cet outil effectue des divisions avec reste et affiche
                        les étapes détaillées du calcul. Il présente le quotient,
                        le reste et la forme décimale du résultat.
                      </p>
                      <p>
                        <strong>Comment utiliser :</strong>
                        Entrez le dividende et le diviseur, puis cliquez sur "Calculer"
                        pour obtenir le résultat et les étapes détaillées.
                      </p>
                      <p>
                        <strong>Explication des résultats :</strong>
                        La calculatrice affiche le résultat sous plusieurs formes :
                        quotient et reste, fraction, et nombre décimal.
                        Les étapes détaillées sont également affichées.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default LongDivisionCalculator;
